import { Client, type Room } from 'colyseus.js';
import type { GameState, InputMessage } from '@rttv/shared';
import { ROOM_NAME } from '@rttv/shared';

const SERVER_URL = (import.meta.env.VITE_SERVER_URL as string | undefined) ?? 'ws://localhost:2567';

class GameClient {
  private client: Client;
  public room: Room<GameState> | null = null;

  constructor() {
    this.client = new Client(SERVER_URL);
  }

  async joinOrCreate(displayName: string, shipId = 'fighter'): Promise<Room<GameState>> {
    this.room = await this.client.joinOrCreate<GameState>(ROOM_NAME, {
      displayName,
      shipId,
    });
    return this.room;
  }

  async joinById(roomId: string, displayName: string, shipId = 'fighter'): Promise<Room<GameState>> {
    this.room = await this.client.joinById<GameState>(roomId, { displayName, shipId });
    return this.room;
  }

  sendInput(input: InputMessage): void {
    this.room?.send('input', input);
  }

  leave(): void {
    this.room?.leave();
    this.room = null;
  }
}

export const gameClient = new GameClient();
